(function () {
  if (window.__wlBusinessCaseModalInit) return;
  window.__wlBusinessCaseModalInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var activeOverlay = null;

    function lockBodyScroll() {
      if (document.body.dataset.dlModalScrollLock != null) return;
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.dataset.dlModalScrollLock = String(y);
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + y + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }

    function unlockBodyScroll() {
      var y = document.body.dataset.dlModalScrollLock;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.dlModalScrollLock;
      if (y != null) window.scrollTo(0, parseInt(y, 10));
    }

    function openModal(modalId, overlay) {
      var modal = document.getElementById(modalId);
      if (!modal) return;

      // Move to body to avoid stacking-context issues with the fixed header/sidebar.
      document.body.appendChild(modal);
      if (overlay) {
        document.body.appendChild(overlay);
        overlay.style.display = 'block';
      }
      activeOverlay = overlay || null;

      modal.style.display = 'flex';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          modal.setAttribute('aria-hidden', 'false');
          modal.classList.add('is-active');
          if (overlay) overlay.classList.add('is-active');
        });
      });
      lockBodyScroll();

      var splideEl = modal.querySelector('.js-wl-business_case-modal-splide');
      if (splideEl && !splideEl.classList.contains('is-initialized') && typeof Splide !== 'undefined') {
        // The slides are nested "wl-business-case-photo-item" theme
        // blocks — see
        // assets/wl-business-case.js's unwrapShopifyBlocks for why the
        // shopify-block wrapper Shopify puts around each one needs to be
        // removed before Splide counts/sizes its slides.
        if (window.__wlBusinessCaseUnwrapShopifyBlocks) {
          window.__wlBusinessCaseUnwrapShopifyBlocks(splideEl.querySelector('.splide__list'));
        }
        new Splide(splideEl, {
          type: 'slide',
          pagination: true,
          arrows: false,
        }).mount();
        splideEl.classList.add('is-initialized');
      }

      var productsSplideEl = modal.querySelector('.js-wl-business_case-modal-products-splide');
      if (productsSplideEl && !productsSplideEl.classList.contains('is-initialized') && typeof Splide !== 'undefined') {
        // The products are nested "wl-business-case-modal-product" theme
        // blocks — see assets/wl-business-case.js's unwrapShopifyBlocks
        // for why the shopify-block wrapper Shopify puts around each one
        // needs to be removed before Splide counts/sizes its slides.
        if (window.__wlBusinessCaseUnwrapShopifyBlocks) {
          window.__wlBusinessCaseUnwrapShopifyBlocks(productsSplideEl.querySelector('.splide__list'));
        }
        var productsSplide = new Splide(productsSplideEl, {
          type: 'slide',
          autoWidth: true,
          gap: '16px',
          pagination: false,
          arrows: false,
          drag: true,
        });
        // Arrows sit in the left info column (next to the text), not
        // inside .media alongside the splide track — search the whole
        // modal rather than productsSplideEl's own parent.
        var prevBtn = modal.querySelector('.wl-business_case-modal-products__arrow--prev');
        var nextBtn = modal.querySelector('.wl-business_case-modal-products__arrow--next');
        if (prevBtn) prevBtn.addEventListener('click', function () { productsSplide.go('<'); });
        if (nextBtn) nextBtn.addEventListener('click', function () { productsSplide.go('>'); });
        productsSplide.mount();
        productsSplideEl.classList.add('is-initialized');
      }
    }

    function closeModal() {
      document.querySelectorAll('.js-wl-business_case-modal.is-active').forEach(function (modal) {
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        setTimeout(function () {
          modal.style.display = 'none';
        }, 200);
      });
      if (activeOverlay) {
        var overlay = activeOverlay;
        overlay.classList.remove('is-active');
        setTimeout(function () {
          overlay.style.display = 'none';
        }, 200);
        activeOverlay = null;
      }
      unlockBodyScroll();
    }

    document.querySelectorAll('.js-wl-business_case-modal-open').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modalId = btn.getAttribute('data-modal-id');
        // Query the whole document, not just btn.closest('.wl-business_case'):
        // the first openModal() call moves the overlay to <body>, so on the
        // 2nd+ open it's no longer a descendant of the case section and a
        // scoped lookup would silently return null (modal opens with no
        // dimmed backdrop behind it).
        var overlay = document.querySelector('.wl-business_case-modal-overlay');
        openModal(modalId, overlay);
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-wl-business_case-modal-close')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  });
})();
